import React, { useState, useEffect } from 'react'
import { Modal, Button, Input, Radio, message, Row, Col } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import '../../css/caregiver.scss'

export default function Caregiver(props) {
  const {
    caregiver,
    patientEmail,
    patientPhone,
    handleConfirm,
    closeModal,
    isLoading,
    email_opt_in
  } = props
  // useEffect(()=>{
  //      setInputData();
  // },[caregiver])

  const [ccMe, setCcMe] = useState(false)
  const [input, setInput] = useState({
    name: caregiver?.name || '',
    email: caregiver?.email || '',
  })

  const [error, setError] = useState({
    email: '',
    name: '',
  })
  const [isDisabled, setIsDisabled] = useState(true)
  const [edit, setIsEdit] = useState(false)

  const setInputValue = (field, value) => {
    verifyInput()
    setInput((prev) => ({ ...prev, [field]: value }))
  }

  const setErrorField = (field, value) => {
    setError((prev) => ({ ...prev, [field]: value }))
  }

  const handleEmailChange = (e) => {
    const value = e.target.value
    setIsEdit(true)
    setInputValue('email', value)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!value) setErrorField('email', 'Email required')
    else if (!emailRegex.test(value)) setErrorField('email', 'Invalid Email')
    else setErrorField('email', '')
  }
  const handleNameChange = (e) => {
    const value = e.target.value
    setIsEdit(true)
    setInputValue('name', value)
    if (!value.trim()) {
      setErrorField('name', 'Name is required')
    } else {
      setErrorField('name', '')
    }
  }
  const handleCCMeChange = (e) => {
    setIsEdit(true)
    setCcMe((prev) => !prev)
  }

  const verifyInput = () => {
    if (input.name == '' || input.email == '' || error.name || error.email)
      setIsDisabled(true)
    else setIsDisabled(false)
  }
  const handleSubmit = () => {
    if(!props.email_opt_in){
      message.error('The patient has unsubscribe email alert please subscribe again')
      return;
    }
    if (input.name == '' || input.email == '') return
    if (error.name) {
      message.error(error.name)
      return
    } else if (error.email) {
      message.error(error.email)
      return
    }
    let emailArr = [input.email]
    if (ccMe) emailArr.push(patientEmail)
    handleConfirm({ ...input, email: emailArr })
  }
  const handleCancel = () => {
    props.closeModal()
    setCcMe(false)
    setInput({ name: caregiver?.name || '', email: caregiver?.email || '' })
  }

  const handleSave = () => {
    setIsEdit(false)
  }

  const handleDiscard = () => {
    setIsEdit(false)
    setInput({ name: caregiver?.name || '', email: caregiver?.email || '' })
    setCcMe(false)
  }
  return (
    <>
      <Row justify='start'>
        <Row className='caregiverInput'>
          <p>Share via email to:</p>
        </Row>
        {/* <Col><EditOutlined  className='caregiver-edit-icon' onClick={()=>setIsEdit(prev=>!prev)}/></Col> */}
      </Row>

      <Row className='caregiverInput'>
        <p>Name</p>
        <Input
          value={input.name}
          // disabled={!edit}
          onChange={handleNameChange}
          className={'input-text'}
        />
        {error.name && <div className='caregiver-edit-error'>{error.name}</div>}
      </Row>

      <Row className='caregiverInput'>
        <p>Email</p>
        <Input
          value={input.email}
          // disabled={!edit}
          onChange={handleEmailChange}
          className={'input-text'}
        />

        {error.email && (
          <div className='caregiver-edit-error'>{error.email}</div>
        )}
      </Row>
      <Radio checked={ccMe} onClick={handleCCMeChange} className='ccme'>
        CC me
      </Radio>
      {!edit && (
        <Row className='caregiver-row'>
          <Button
            className=' caregiver-btn'
            style={{ backgroundColor: 'red' }}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            className='caregiver-btn'
            style={{ backgroundColor: `${isLoading ? 'grey' : '#012448'}` }}
            onClick={handleSubmit}
            disabled={isLoading}
          >
            Confirm
          </Button>
        </Row>
      )}
      {edit && (
        <Row className='caregiver-row'>
          <Button
            className=' caregiver-btn'
            style={{ backgroundColor: 'red' }}
            onClick={handleDiscard}
          >
            Cancel
          </Button>
          <Button
            className='caregiver-btn'
            style={{ backgroundColor: '#012448', minWidth: 100 }}
            onClick={handleSave}
          >
            Save
          </Button>
        </Row>
      )}
    </>
  )
}
